import { render, staticRenderFns } from "./DispatchForm.html?vue&type=template&id=11487592&scoped=true&external"
import script from "./DispatchForm.js?vue&type=script&lang=js&external"
export * from "./DispatchForm.js?vue&type=script&lang=js&external"
import style0 from "./DispatchForm.vue?vue&type=style&index=0&id=11487592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11487592",
  null
  
)

export default component.exports